// @flow
const generateFallbackShopUrl = (slug) => `https://www.tablecheck.com/${slug}`;

const generateFallbackBookingUrl = (slug) =>
  `https://www.tablecheck.com/shops/${slug}/reserve`;

const generateShopCardUrls = ({
  slug,
  shopUrl = generateFallbackShopUrl(slug),
  bookingUrl = generateFallbackBookingUrl(slug),
  menuListId,
  utmSource,
  locale
}: {
  bookingUrl?: string,
  locale: string,
  menuListId?: string,
  shopUrl?: string,
  slug: string,
  utmSource: string
}): { bookingUrlWithUtm: string, shopUrlWithUtm: string } => {
  const [shopUrlWithUtm, bookingUrlWithUtm] = [shopUrl, bookingUrl].map(
    (baseUrl) => {
      const url = new URL(baseUrl);

      url.pathname = `/${locale}${url.pathname}`;

      const queryParams = new URLSearchParams();
      if (menuListId) {
        queryParams.append('menu_lists[]', menuListId.toString());
      }
      queryParams.append('utm_source', utmSource);
      return `${url.toString()}?${queryParams
        .toString()
        .replace('%5B%5D', '[]')}`;
    }
  );
  return { shopUrlWithUtm, bookingUrlWithUtm };
};

export default generateShopCardUrls;
